import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Bars3Icon,
  XMarkIcon,
  UserIcon,
  ArrowRightStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import Dropdown from "./Dropdown";
import ChangePassword from "../pages/User/ChangePassword";
import { useStateContext } from "../contexts/ContextProvider";

const Navbar2 = ({ logo = "Check Printer", links = [] }) => {
const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
const {handleClick,setToken}=useStateContext();
const [showChangePassword,setShowChangePassword]=useState(false);

  // Dropdown items for account actions
  const dropdownItems = [
    {
      label: "Mot de passe",
      icon: UserIcon,
      onClick: () => setShowChangePassword(true)
    }, 
    {
      label: "Deconnexion",
      icon: ArrowRightStartOnRectangleIcon,
      onClick: () => logout(),
    },
  ];

  const logout=()=>{
    handleClick('');
    localStorage.removeItem('ACCESS_TOKEN');
    setToken(null);
  }

  const closeShowChangePassword=()=>{
    setShowChangePassword(false);
  }

  return (
    <nav className="bg-white border-b border-zinc-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <NavLink to="/" className="flex items-center">
              {typeof logo === "string" ? (
                <span className="text-xl font-bold text-zinc-900">{logo}</span>
              ) : (
                logo
              )}
            </NavLink>
          </div>

          {/* Desktop Links and Dropdown */}
          <div className="hidden md:flex items-center gap-6">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? "text-zinc-900 border-b-2 border-zinc-900"
                      : "text-zinc-600 hover:text-zinc-900"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Dropdown
              trigger={
                <div className="flex items-center gap-2 cursor-pointer text-sm font-medium text-zinc-700 hover:text-zinc-900 transition-colors duration-200">
                  <div className="h-8 w-8 rounded-full bg-zinc-200 flex items-center justify-center">
                    <UserIcon className="h-5 w-5 text-zinc-600" />
                  </div>
                  <span>User</span>
                </div>
              }
              items={dropdownItems}
              className="w-40"
              align="right"
            />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2 rounded-md text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 transition-all duration-200"
            >
              {isMobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-zinc-200 bg-white">
          <div className="px-4 py-3 flex flex-col gap-3">
            {links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-sm font-medium py-2 transition-colors duration-200 ${
                    isActive
                      ? "text-zinc-900"
                      : "text-zinc-600 hover:text-zinc-900"
                  }`
                }
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </NavLink>
            ))}
            <Dropdown
              trigger={
                <div className="flex items-center gap-2 text-sm font-medium text-zinc-700 py-2">
                  <div className="h-8 w-8 rounded-full bg-zinc-200 flex items-center justify-center">
                    <UserIcon className="h-5 w-5 text-zinc-600" />
                  </div>
                  <span>User</span>
                </div>
              }
              items={dropdownItems}
              className="w-full"
              align="left"
              position="bottom"
            />
          </div>
        </div>
      )}
      {
        showChangePassword ? <ChangePassword onClose={closeShowChangePassword}/> : <></>
      }
    </nav>
  );
};

export default Navbar2;
